import axios from 'axios';

export default {
    FETCH_CONFIGURATIONS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('freepreview/getAllAppConfiguration')
                .then((response) => {
                    const { data: { data } } = response;
                    localStorage.setItem('configuration', JSON.stringify(data));
                    commit('SET_CONFIGURATIONS', data);
                    commit('TOGGLE_LOADING', false);
                    resolve(data);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_CONFIGURATION({commit, dispatch}, payload){
      return new Promise((resolve, reject) => {
        commit('TOGGLE_LOADING', true);
        axios.post('freepreview/updateAppConfiguration', payload)
          .then((response) => {
            const { data: { data } } = response;
            commit('TOGGLE_LOADING', false);
            resolve(data);
          })
          .catch((error) => {
            console.log('UPDATE_CONFIGURATION action fetch error : ', error);
            reject(error);
            commit('TOGGLE_LOADING', false);
          });
      })
    },
  REMOVE_IMAGE_FILE({commit, dispatch}, fileName){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      let payload = {
        displayTitle: fileName
      }
      axios.post(`user/deleteS3Object`, payload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ERROR Deleting the file/image : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPLOAD_IMAGES ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);

      console.log('payload image', payload.small_image)
      let formData = new FormData();
      formData.append("image_file", payload.small_image);
      //formData.append("file", payload.large_image);
      console.log('form data', formData)
      return axios.post(`/user/uploadImage`, formData).then((response) => {
        commit('TOGGLE_LOADING', false);
        const { data: { data } } = response;
        console.log('CREATE_EXPERT response ', response);
        resolve(data);
      }, (error) => {
        commit('TOGGLE_LOADING', false);
        console.log('CREATE_EXPERT error ', error);
        reject(error);
      })
    })
  },
  FETCH_IMAGES ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('user/getS3BucketListing')
        .then((response) => {
          const { data: { data } } = response;
          localStorage.setItem('imagelist', JSON.stringify(data));
          commit('SET_IMAGES', data);
          commit('TOGGLE_LOADING', false);
          resolve(data);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/configurations/actions.js